/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, MouseEventHandler, useMemo } from 'react';
import { CardActionArea, Grid, Typography } from '@mui/material';
import { kebabCase } from 'lodash';
import { cardAddressSX, cardNickSX } from '@/components/blocks/Card/styles/cardContent';
import { generateAddressFullByUnknown } from '@/utils/addressTransform';

type Props = {
	content: JSX.Element;
	divider?: boolean;
	onCardArea?: MouseEventHandler<HTMLButtonElement>;
	testId: string;
	personData?: boolean;
};

const GarnishPerson: FC<{ content: JSX.Element }> = ({ content }) => {
	const deliveryAddress = content.props.addressData;
	return content ? (
		<Grid item xs sx={{ width: '100%' }}>
			<Typography fontSize={'var(--font-size-body)'} fontWeight={600}>
				{deliveryAddress.fullName} {deliveryAddress?.attributes?.[0]?.value}
			</Typography>
			<Typography fontSize={'var(--font-size-body)'}>{deliveryAddress.email1}</Typography>
			<Typography fontSize={'var(--font-size-body)'}>{deliveryAddress.phone1}</Typography>
		</Grid>
	) : null;
};

const Garnish: FC<{ content: JSX.Element }> = ({ content }) => {
	const deliveryAddress = content.props.addressData;
	const mainAddress = deliveryAddress.nickName === deliveryAddress.email1;

	const addressFull = useMemo(
		() => generateAddressFullByUnknown(deliveryAddress),
		[deliveryAddress]
	);

	return content ? (
		<Grid item xs sx={{ width: '100%' }}>
			<Typography
				fontSize={'var(--font-size-body)'}
				component={'h2'}
				variant="body2"
				fontWeight={600}
				sx={cardNickSX}
			>
				{mainAddress ? 'Dirección principal' : deliveryAddress.nickName}
			</Typography>
			<Typography
				sx={{
					...cardAddressSX,
					fontStyle: !addressFull ? 'italic' : undefined,
					color: !addressFull ? 'red' : undefined,
				}}
				fontSize={'var(--font-size-default)'}
			>
				{addressFull ? addressFull : 'Ingrese dirección completa'}
			</Typography>
		</Grid>
	) : null;
};

export const CardMain: FC<Props> = ({ content, onCardArea, testId, personData }) =>
	content ? (
		<>
			{onCardArea ? (
				<CardActionArea
					id={kebabCase(`card-action-area-${testId}`)}
					data-testid={kebabCase(`card-action-area-${testId}`)}
					onClick={onCardArea}
				>
					{personData ? <GarnishPerson content={content} /> : <Garnish content={content} />}
				</CardActionArea>
			) : (
				<>{personData ? <GarnishPerson content={content} /> : <Garnish content={content} />}</>
			)}
			{/* {divider ? <Divider /> : null} */}
		</>
	) : null;
